import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { environment } from 'src/environments/environment';

@Component({
  selector: "app-waiting-list-history",
  templateUrl: "./waiting-list-history.component.html",
})
export class WaitingListHistoryComponent implements OnInit {
  path: any;
  selectedPatientIdByUrl = "";
  selectedName = "";
  activetab: any;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  sortColumn = "createdOn";
  orderColumn = "desc";
  search = "";
  searchText = "";
  routerName = "";
  maxSizeItemValue: any;
  dailypageno = 1;
  waitinglist = [];

  constructor(
    private appservice: AppService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  formateMask(phonecode) {
    if (phonecode) {
      if (phonecode === "+91" || phonecode === +91) {
        return environment.indiaPhoneMask;
      } else {
        return environment.usPhoneMask;
      }
    }
  }

  searchDate = "";
  searchFromTime = "";
  searchToTime = "";
  ngOnInit() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 4) {
      this.selectedPatientIdByUrl = Splitpath[3];
    }

    if (localStorage.getItem("fromTime") && localStorage.getItem("toTime") && localStorage.getItem("scheduleDate")) {
      this.searchDate = localStorage.getItem("scheduleDate");
      this.searchFromTime = localStorage.getItem("fromTime");
      this.searchToTime = localStorage.getItem("toTime");
    }
    this.getwaitinglist("");
  }

  cptCodeList = [];
  selfamount = 0;
  insuranceList = [];
  callScheduleappointment(wait) {
    this.cptCodeList = [];
    this.insuranceList = [];
    if (
      wait &&
      wait["scheduleWaitingTime"][0]["scheduleWaitingProcedure"].length > 0
    ) {
      for (
        let index = 0;
        index <
        wait["scheduleWaitingTime"][0]["scheduleWaitingProcedure"].length;
        index++
      ) {
        this.cptCodeList.push(
          wait["scheduleWaitingTime"][0]["scheduleWaitingProcedure"][index]
            .cptCode
        );
        if (wait["payMode"] === "self") {
          this.selfamount +=
            wait["scheduleWaitingTime"][0]["scheduleWaitingProcedure"][
              index
            ].tcProcedure.amount;
        }
      }
    }

    if (wait["waitingInsurance"].length > 0) {
      for (let index = 0; index < wait["waitingInsurance"].length; index++) {
        this.insuranceList.push({
          insId: wait["waitingInsurance"][index].insurance.id,
          insType: wait["waitingInsurance"][index].insuranceType
            ? wait["waitingInsurance"][index].insuranceType.id
            : "",
          insTmpId: wait["waitingInsurance"][index].insurance.id,
          insExists: false,
          insName: wait["waitingInsurance"][index].insurance
            ? wait["waitingInsurance"][index].insurance.name
            : "",
        });
      }
    }
    const scheduledData: any = {
      scheduleOn:
        wait["scheduleWaitingTime"][0]["scheduleWaitingProcedure"][0][
        "scheduledOn"
        ],
      location: wait["choosenLocation"],
      insuranceList: this.insuranceList,
      cptCodeList: this.cptCodeList,
      payMode: wait["payMode"],
      patient: wait["patient"],
    };

    if (wait["payMode"] === "self") {
      scheduledData.amount = this.selfamount;
    }

    sessionStorage.setItem("waitinglistdata", JSON.stringify(scheduledData));
    sessionStorage.setItem("waitingid", wait["id"]);
    this.router.navigate([
      `/${localStorage.getItem("testCode").toString()}/schedule-appointment`,
    ]);
  }

  getwaitinglist(event) {
    let data;
    if (!this.searchFromTime) {
      this.searchFromTime = "";
    }
    if (!this.searchToTime) {
      this.searchToTime = "";
    }
    if (event) {
      data = {
        tcId: localStorage.getItem("testCenterId"),
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        search: this.searchText,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        searchDate: this.searchDate,
        searchFromTime: this.searchFromTime,
        searchToTime: this.searchToTime

      };
    } else {
      data = {
        tcId: localStorage.getItem("testCenterId"),
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        search: this.searchText,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        searchDate: this.searchDate,
        searchFromTime: this.searchFromTime,
        searchToTime: this.searchToTime
      };
    }

    this.appservice.getalltcwaitinglist(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] == 200) {
        if (res["entity"]) {
          this.waitinglist = res["entity"];
          this.totalItems = res["count"];
        }
      } else {
        this.waitinglist = [];
        this.totalItems = 0;
      }
    });
  }

  pageChanged(event: any): void {
    this.getwaitinglist(event);
  }

  onBlurSearchMethod() {
    this.searchText = this.search;
    this.currentPage = 1;
    this.getwaitinglist("");
  }

  ngOnDestroy() {
    localStorage.removeItem("scheduleDate");
    localStorage.removeItem("fromTime");
    localStorage.removeItem("toTime");
  }

  refreshPatient() {
    
    this.searchFromTime = "";
    this.searchToTime = "";
    this.searchDate = "";

    this.search = "";
    this.searchText = "";
    this.getwaitinglist("");
  }

  getwaitinglistbysort(type, param) {
    let data;
    if (event) {
      data = {
        tcId: localStorage.getItem("testCenterId"),
        pageNumber: this.page ? this.page : 1,
        pageRecord: this.maxSizeItem,
        search: this.search ? this.search : "",
        sortColumn: param,
        sortType: type,
        searchDate: "",
        searchFromTime: "",
        searchToTime: "",
      };
    }
    this.appservice.getalltcwaitinglist(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.waitinglist = res["entity"];
          this.totalItems = res["count"];
        }
      } else {
        this.waitinglist = [];
        this.totalItems = 0;
      }
    });
  }
}
